import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const AcceptInvitePage: React.FC = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) setError('קישור ההזמנה לא תקין');
  }, [token]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 6) return setError('הסיסמה חייבת להיות לפחות 6 תווים');
    if (password !== confirm) return setError('הסיסמאות אינן תואמות');
    setLoading(true);
    setError('');
    try {
      await axios.post('/api/permissions/accept-invite', { token, password });
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err: any) {
      setError(err?.response?.data?.error || 'שגיאה בקבלת ההזמנה');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0D47A1] via-[#1565C0] to-[#1976D2] flex items-center justify-center p-4" dir="rtl">
      <div className="bg-white rounded-3xl shadow-2xl p-6 md:p-8 w-full max-w-sm">
        {done ? (
          <div className="text-center">
            <div className="text-5xl mb-4">✅</div>
            <h2 className="text-xl font-bold text-gray-800 mb-2">הסיסמה הוגדרה בהצלחה!</h2>
            <p className="text-gray-500 text-sm">מועבר לעמוד הכניסה...</p>
          </div>
        ) : (
          <>
            <div className="text-center mb-6">
              <div className="text-4xl mb-2">🎉</div>
              <h1 className="text-xl font-bold text-gray-800">קבל גישה למערכת</h1>
              <p className="text-gray-500 text-sm mt-1">הגדר סיסמה לכניסה ראשונה</p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-gray-600 mb-1.5">סיסמה חדשה</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="לפחות 6 תווים" autoFocus
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:ring-2 focus:ring-[#1565C0] outline-none" />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-600 mb-1.5">אימות סיסמה</label>
                <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                  placeholder="הקלד שוב"
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:ring-2 focus:ring-[#1565C0] outline-none" />
              </div>
              {error && <p className="text-red-500 text-sm bg-red-50 px-3 py-2 rounded-xl">⚠️ {error}</p>}
              <button type="submit" disabled={loading || !token}
                className="w-full bg-[#1565C0] hover:bg-[#0D47A1] text-white font-bold py-3 rounded-xl transition-all disabled:opacity-50">
                {loading ? 'שומר...' : 'כניסה ראשונה →'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default AcceptInvitePage;
